import React, { Component, Fragment } from 'react'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import Calc1 from './Calc1'
import Calc2 from './Calc2'
import calc1data from './data/calc1'
import calc2data from './data/calc2'
import { __ } from '../../services/translate'

export default class LoadCalculator extends Component {

  state = {
    active: 'calc1'
  }

  toggle = (tab) => this.setState({ active: tab })

  render() {
    return (
      <Fragment>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={this.state.active === 'calc1' ? 'active' : ''}
              onClick={() => this.toggle('calc1')}
            >
              {__('Metoda třecího přivázání')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={this.state.active === 'calc2' ? 'active' : ''}
              onClick={() => this.toggle('calc2')}
            >
              {__('Metoda přímého přivazovaní')}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.active}>
          <TabPane tabId="calc1">
            <Calc1 data={calc1data}/>
          </TabPane>
          <TabPane tabId="calc2">
            <Calc2 data={calc2data}/>
          </TabPane>
        </TabContent>
      </Fragment>
    )
  }
}
